import React from 'react';
import About from '../About/About';
import AppWrapper from '../AppWrapper/AppWrapper';
import Banner from '../Banner/Banner';
import Category from '../Category/Category';
import PopularCollection from '../PopularCollection/PopularCollection';
import Steps from '../Steps/Steps';
import SubBanner from '../SubBanner/SubBanner';
import Subscribe from '../Subscribe/Subscribe';
import WideBanner from '../WideBanner/WideBanner';
import Trending from './Tranding/Trending';

const Home = () => {
    return (
        <div>
              
           <Banner/>
           <About/>
           {/* <Advertises/> */}
           <Category/>
           <PopularCollection/>
           <WideBanner/>
           <SubBanner/>
          <Steps/>
           <AppWrapper/>
           <Trending/>
           <Subscribe/>
           
        </div>
    );
};

export default Home;